/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CreatePopStoreThemeTemplateRequest,
    IdResponse,
    ModeratePopStoreThemeTemplateRequest,
    PopStoreThemeTemplateResponse,
    ThemeTemplateSubscriptionLevelResponse,
    ThemeTemplateTypesResponse,
    UpdatePopStoreThemeTemplateRequest,
} from '../models';

export interface PopStoreThemeTemplateApiControllerCreateThemeRequest {
    storeId: string;
    createPopStoreThemeTemplateRequest: CreatePopStoreThemeTemplateRequest;
}

export interface PopStoreThemeTemplateApiControllerDeleteThemeTemplateRequest {
    storeId: string;
    id: string;
}

export interface PopStoreThemeTemplateApiControllerGetThemeTemplateRequest {
    id: string;
}

export interface PopStoreThemeTemplateApiControllerModerateThemeTemplateRequest {
    id: string;
    moderatePopStoreThemeTemplateRequest: ModeratePopStoreThemeTemplateRequest;
}

export interface PopStoreThemeTemplateApiControllerUpdateThemeTemplateRequest {
    storeId: string;
    id: string;
    updatePopStoreThemeTemplateRequest: UpdatePopStoreThemeTemplateRequest;
}

/**
 * 
 */
export class ThemeTemplatesApi extends runtime.BaseAPI {

    /**
     */
    async popStoreThemeTemplateApiControllerCreateThemeRaw(requestParameters: PopStoreThemeTemplateApiControllerCreateThemeRequest): Promise<runtime.ApiResponse<PopStoreThemeTemplateResponse>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling popStoreThemeTemplateApiControllerCreateTheme.');
        }

        if (requestParameters.createPopStoreThemeTemplateRequest === null || requestParameters.createPopStoreThemeTemplateRequest === undefined) {
            throw new runtime.RequiredError('createPopStoreThemeTemplateRequest','Required parameter requestParameters.createPopStoreThemeTemplateRequest was null or undefined when calling popStoreThemeTemplateApiControllerCreateTheme.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/theme-templates`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createPopStoreThemeTemplateRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async popStoreThemeTemplateApiControllerCreateTheme(requestParameters: PopStoreThemeTemplateApiControllerCreateThemeRequest): Promise<PopStoreThemeTemplateResponse> {
        const response = await this.popStoreThemeTemplateApiControllerCreateThemeRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async popStoreThemeTemplateApiControllerDeleteThemeTemplateRaw(requestParameters: PopStoreThemeTemplateApiControllerDeleteThemeTemplateRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling popStoreThemeTemplateApiControllerDeleteThemeTemplate.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling popStoreThemeTemplateApiControllerDeleteThemeTemplate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/theme-templates/{id}`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async popStoreThemeTemplateApiControllerDeleteThemeTemplate(requestParameters: PopStoreThemeTemplateApiControllerDeleteThemeTemplateRequest): Promise<void> {
        await this.popStoreThemeTemplateApiControllerDeleteThemeTemplateRaw(requestParameters);
    }

    /**
     */
    async popStoreThemeTemplateApiControllerGetThemeSubscriptionLevelsRaw(): Promise<runtime.ApiResponse<Array<ThemeTemplateSubscriptionLevelResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/theme-template-levels`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async popStoreThemeTemplateApiControllerGetThemeSubscriptionLevels(): Promise<Array<ThemeTemplateSubscriptionLevelResponse>> {
        const response = await this.popStoreThemeTemplateApiControllerGetThemeSubscriptionLevelsRaw();
        return await response.value();
    }

    /**
     */
    async popStoreThemeTemplateApiControllerGetThemeTemplateRaw(requestParameters: PopStoreThemeTemplateApiControllerGetThemeTemplateRequest): Promise<runtime.ApiResponse<PopStoreThemeTemplateResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling popStoreThemeTemplateApiControllerGetThemeTemplate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/theme-templates/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async popStoreThemeTemplateApiControllerGetThemeTemplate(requestParameters: PopStoreThemeTemplateApiControllerGetThemeTemplateRequest): Promise<PopStoreThemeTemplateResponse> {
        const response = await this.popStoreThemeTemplateApiControllerGetThemeTemplateRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async popStoreThemeTemplateApiControllerGetThemeTemplateTypeRaw(): Promise<runtime.ApiResponse<Array<ThemeTemplateTypesResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/theme-template-types`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async popStoreThemeTemplateApiControllerGetThemeTemplateType(): Promise<Array<ThemeTemplateTypesResponse>> {
        const response = await this.popStoreThemeTemplateApiControllerGetThemeTemplateTypeRaw();
        return await response.value();
    }

    /**
     */
    async popStoreThemeTemplateApiControllerModerateThemeTemplateRaw(requestParameters: PopStoreThemeTemplateApiControllerModerateThemeTemplateRequest): Promise<runtime.ApiResponse<IdResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling popStoreThemeTemplateApiControllerModerateThemeTemplate.');
        }

        if (requestParameters.moderatePopStoreThemeTemplateRequest === null || requestParameters.moderatePopStoreThemeTemplateRequest === undefined) {
            throw new runtime.RequiredError('moderatePopStoreThemeTemplateRequest','Required parameter requestParameters.moderatePopStoreThemeTemplateRequest was null or undefined when calling popStoreThemeTemplateApiControllerModerateThemeTemplate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/theme-templates/{id}:moderate`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.moderatePopStoreThemeTemplateRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async popStoreThemeTemplateApiControllerModerateThemeTemplate(requestParameters: PopStoreThemeTemplateApiControllerModerateThemeTemplateRequest): Promise<IdResponse> {
        const response = await this.popStoreThemeTemplateApiControllerModerateThemeTemplateRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async popStoreThemeTemplateApiControllerUpdateThemeTemplateRaw(requestParameters: PopStoreThemeTemplateApiControllerUpdateThemeTemplateRequest): Promise<runtime.ApiResponse<PopStoreThemeTemplateResponse>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling popStoreThemeTemplateApiControllerUpdateThemeTemplate.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling popStoreThemeTemplateApiControllerUpdateThemeTemplate.');
        }

        if (requestParameters.updatePopStoreThemeTemplateRequest === null || requestParameters.updatePopStoreThemeTemplateRequest === undefined) {
            throw new runtime.RequiredError('updatePopStoreThemeTemplateRequest','Required parameter requestParameters.updatePopStoreThemeTemplateRequest was null or undefined when calling popStoreThemeTemplateApiControllerUpdateThemeTemplate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/theme-templates/{id}`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updatePopStoreThemeTemplateRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async popStoreThemeTemplateApiControllerUpdateThemeTemplate(requestParameters: PopStoreThemeTemplateApiControllerUpdateThemeTemplateRequest): Promise<PopStoreThemeTemplateResponse> {
        const response = await this.popStoreThemeTemplateApiControllerUpdateThemeTemplateRaw(requestParameters);
        return await response.value();
    }

}
